import channelagent from './channelagent';

export default {
  changeMerchant: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000523","请先选择商家") /* "请先选择商家" */,
  merchantNoPlatform: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000524","商家不是平台") /* "商家不是平台" */,
  changeSalesOrg: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000525","请先选择销售组织") /* "请先选择销售组织" */,
  changeBizAndOrg: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000526","请先选择商家和组织") /* "请先选择商家和组织" */,
  channelagent
};
